// Base 3 diagnostic questions (12 questions across 5 spheres)
const base3 = [
    // ── I Sfera: Bendroji energija ir savimoka — 3 questions ──
    {
      id: 'q1',
      sphere: 'bendra',
      question: 'Kai manyje kyla nauja idėja ar įkvėpimas:',
      choices: {
        a: 'Drąsiai ją išreiškiu – kalbu, kuriu ar dalinuosi ja su kitais, nes mėgaujuosi saviraiška.',
        b: 'Pasilieku ją sau, nes bijau, kad nuvertins arba kad neišeis taip gerai, kaip įsivaizduoju.',
        c: 'Pasveriu, ar verta – kartais išsakau, kartais palieku idėją tik sau, priklausomai nuo situacijos.',
      },
    },
    {
      id: 'q2',
      sphere: 'bendra',
      question: 'Kai aplinkui tvyro sunki ar prislėgta nuotaika:',
      choices: {
        a: 'Natūraliai įnešu lengvumo ir šypsenos – moku pakelti nuotaiką sau ir kitiems.',
        b: 'Pats pasineriu į liūdesį arba slepiu jausmus po dirbtiniu linksmumu, kad neparodyčiau, kaip jaučiuosi.',
        c: 'Stengiuosi išlikti pozityvus, bet jei nepavyksta, tiesiog ramiai prisitaikau prie bendros nuotaikos.',
      },
    },
    {
      id: 'q3',
      sphere: 'bendra',
      question: 'Kai reikia susidoroti su kasdienėmis pareigomis ir smulkmenomis:',
      choices: {
        a: 'Net rutiną paverčiu žaismingesne – randu būdą, kaip ją atlikti lengvai ir su gera nuotaika.',
        b: 'Greitai pavargstu, blaškausi tarp darbų ir dažnai atidedu nemėgstamas užduotis paskutinei minutei.',
        c: 'Atlieku, ką reikia, bet stengiuosi nuobodžius darbus išspręsti greitai, kad liktų laiko maloniems dalykams.',
      },
    },
    // ── II Sfera: Darbas ir karjera — 2 questions ──
    {
      id: 'q4',
      sphere: 'karjera',
      question: 'Kai reikia pristatyti savo darbą ar idėją grupei žmonių:',
      choices: {
        a: 'Jaučiuosi savo stichijoje – laisvai kalbu, įtraukiu klausytojus ir mėgaujuosi dėmesiu.',
        b: 'Stipriai jaudinuosi, vengiu viešo kalbėjimo ir mieliau leidžiu pristatyti kitam.',
        c: 'Pasiruošiu iš anksto ir pristatau dalykiškai, be ypatingo malonumo, bet ir be didelio streso.',
      },
    },
    {
      id: 'q5',
      sphere: 'karjera',
      question: 'Kai darbe atsiranda erdvės kūrybai ar naujiems sprendimams:',
      choices: {
        a: 'Iškart pasiūlau šviežių idėjų ir mėgaujuosi galimybe kurti kažką naujo.',
        b: 'Lieku prie įprastų sprendimų, nes abejoju savo idėjų verte arba bijau kritikos.',
        c: 'Pasiūlau idėją tik tada, kai esu tikras, kad ji tikrai pasiteisins ir bus priimta.',
      },
    },
    // ── III Sfera: Santykiai ir partnerystė — 2 questions ──
    {
      id: 'q6',
      sphere: 'santykiai',
      question: 'Kai santykiuose kyla įtampa ar nesusikalbėjimas:',
      choices: {
        a: 'Atvirai ir nuoširdžiai išsakau savo jausmus, nes tikiu, kad pokalbis viską išsprendžia.',
        b: 'Užsidarau, nutylu arba aštriais žodžiais įgeliu kitam, o paskui gailiuosi.',
        c: 'Palaukiu, kol nurims emocijos, ir tik tada ramiai aptariu situaciją.',
      },
    },
    {
      id: 'q7',
      sphere: 'santykiai',
      question: 'Kai galvoju apie tai, kas mane traukia artimame žmoguje:',
      choices: {
        a: 'Vertinu lengvumą, humorą ir gebėjimą kartu nuoširdžiai pasidžiaugti gyvenimu.',
        b: 'Greitai prarandu susidomėjimą arba nuolat ieškau naujų įspūdžių, nes bijau nuobodulio ir įsipareigojimo.',
        c: 'Ieškau pusiausvyros tarp linksmo bendravimo ir ramaus, stabilaus artumo.',
      },
    },
    // ── IV Sfera: Finansai ir resursai — 2 questions ──
    {
      id: 'q8',
      sphere: 'finansai',
      question: 'Kai į rankas patenka laisvų pinigų:',
      choices: {
        a: 'Moku jais džiaugtis, bet ir protingai paskirstau – malonumams ir prasmingiems tikslams.',
        b: 'Greitai išleidžiu malonumams ar smulkmenoms, o paskui pritrūksta svarbesniems dalykams.',
        c: 'Dalį atidedu, dalį skiriu malonumams – stengiuosi laikytis aiškaus saiko.',
      },
    },
    {
      id: 'q9',
      sphere: 'finansai',
      question: 'Kai reikia užsidirbti ar pritraukti pajamų:',
      choices: {
        a: 'Pasitikiu savo talentais ir kūrybiškumu – tikiu, kad gabumai man atneša pinigų.',
        b: 'Jaučiuosi nesaugus dėl pinigų, dažnai svyruoju nuo pertekliaus prie trūkumo ir vengiu apie tai galvoti.',
        c: 'Stengiuosi turėti stabilų pajamų šaltinį, o kūrybai ar pomėgiams skiriu laiką šalia jo.',
      },
    },
    // ── V Sfera: Savirealizacija ir gyvenimo situacija — 3 questions ──
    {
      id: 'q10',
      sphere: 'savirealizacija',
      question: 'Kai pajuntu, kad mano gyvenime per mažai džiaugsmo ar saviraiškos:',
      choices: {
        a: 'Sąmoningai ieškau, kur galiu kurti, mokytis ar išreikšti save, ir grąžinu sau gyvybingumą.',
        b: 'Skęstu nusivylime ar apatijoje ir laukiu, kol ši būsena praeis savaime.',
        c: 'Kai tik atsiranda laisvo laiko ir energijos, po truputį grįžtu prie savo mėgstamų veiklų.',
      },
    },
    {
      id: 'q11',
      sphere: 'savirealizacija',
      question: 'Kai galvoju apie savo talentus ir gebėjimus:',
      choices: {
        a: 'Drąsiai juos puoselėju ir rodau pasauliui, nes tikiu savo unikalumu.',
        b: 'Nuvertinu save, lyginuosi su kitais ir jaučiu, kad mano gabumai yra nieko verti.',
        c: 'Pripažįstu savo stipriąsias puses, bet jas realizuoju atsargiai, tik patikimoje aplinkoje.',
      },
    },
    {
      id: 'q12',
      sphere: 'savirealizacija',
      question: 'Kai gyvenimas pateikia sunkumų ar nusivylimų:',
      choices: {
        a: 'Surandu vilties ir prasmės net sunkmetyje – tikiu, kad po lietaus visada išaušta.',
        b: 'Pasineriu į dramą, perdėtai išgyvenu arba bandau pabėgti nuo skausmingų jausmų.',
        c: 'Leidžiu sau paliūdėti, bet sąmoningai ieškau būdų, kaip vėl pakelti sau nuotaiką.',
      },
    },
  ];

export default base3;
